import "./sass/private.scss";
import { registerFilterSheetTracking } from "./filtersheet/FilterSheetTracking";
import { registerQuickFilterButtonHandlers } from "./quickfilter/QuickFilterButton";
import registerFilterFormActionsHandlers, { initializeLayoutField } from "./filter/FilterFormActions";
import { SubmitOnChangeListener } from "./filter/SubmitOnChange";
import { initToggles, isNotActive } from "./toggle/Toggle";
import registerExpanderHandlers from "./expander/Expander";

import "./filter/FilterSection";
import { OverflowBox } from "./overflowBox/OverflowBox";
import { initExperiments } from "./experiment/Experiments";
import { registerFilterSheetEventListeners } from "./filtersheet/FilterSheetEventListeners";
import { registerFilterReloading } from "./multifiltering/init";
import { registerFilterFormSelectAllButtons } from "./filter/form/SelectAllButton";
import { registerSorting } from "./sorting/init";
import { registerRefinementBar } from "./refinementBar/init";
import { registerFilterStuff } from "./filter/init";
import { FilterSection } from "./filter/FilterSection";
import { Slider } from "./filter/slider/Slider";
import registerFilterTracking from "./filter/FilterTracking";
import { FilterlistExpander } from "./filterlistExpander/FilterlistExpander";
import { ChangeCounter } from "./filter/ChangeCounter";
import registerSvelteComponentInitialization from "./filter/SvelteComponentInitialization";
import { registerSveltePopularFacetValuesListeners } from "./filter/SveltePopularFacetValues";
import { registerFilterSectionChangedListener } from "./filter/FilterSectionChangedAction";
import { registerCategoryPathFacet } from "./filter/SvelteFacet";
import { onReady } from "@otto-ec/global-resources/dom";
import { registerOcFilterSheetHandlers } from "./filtersheet/OcFilterSheetHandlers";
import { CustomRangeInput } from "./filter/slider/CustomRangeInput";
import { registerCategoryPathValuesSelection } from "./categorypath/categoryPath";

onReady.subscribe(() => {
  initToggles();
  initExperiments();

  registerExpanderHandlers();
  OverflowBox.register();
  registerSvelteComponentInitialization();

  Slider.register();
  registerFilterSheetTracking();
  FilterSection.register();
  registerOcFilterSheetHandlers();
  registerFilterSheetEventListeners();
  registerQuickFilterButtonHandlers();
  registerFilterFormSelectAllButtons();
  registerFilterFormActionsHandlers();
  registerCategoryPathFacet();
  registerFilterStuff();
  FilterlistExpander.register();
  registerSorting();
  SubmitOnChangeListener.register();
  ChangeCounter.register();
  registerSveltePopularFacetValuesListeners();
  registerCategoryPathValuesSelection();
  registerRefinementBar();
  registerFilterTracking();
  registerFilterReloading();
  registerFilterSectionChangedListener();
  CustomRangeInput.register();

  /*                                   */
  if (isNotActive("HEUREKA_2381_DONT_RETRIEVE_ENTRYRULE_FROM_HISTORY")) {
    initializeLayoutField();
  }
});
